<template>
  <div class="modal fade" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{content}}
        </div>
        <div class="modal-footer">
          <button class="btn btn-light" data-dismiss="modal">Close</button>
          <button class="btn btn-primary" @click.prevent="confirm">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    title: String,
    content: String,
    onConfirm: Function,
    index: Number
  },
  methods: {
    confirm() {
      if(this.onConfirm) {
        this.onConfirm(this.index)
      }
    }
  }
}
</script>

